import { useState } from 'react';

import { Text } from '@chakra-ui/react';
import { MdPhoneDisabled } from 'react-icons/md';

import { useOnSipRegistrationFailureSubscription } from '../../gql/generated/graphql';

import NotificationToast from './components/NotificationToast';

import { useCallsContext } from '../../libs/callsContext';
import { formatPhoneNumberForDisplay } from '../../libs/utils';

type SipFailureNotification = {
  callerNumber: string | null;
};

const SipFailureHandler = () => {
  const { setSipFailureOccurred } = useCallsContext();
  const [notification, setNotification] = useState<SipFailureNotification | null>(null);

  useOnSipRegistrationFailureSubscription({
    onData: ({ data: { data } }) => {
      if (!data?.onSipRegistrationFailure) {
        return;
      }

      setSipFailureOccurred(true);

      setNotification({
        callerNumber: data.onSipRegistrationFailure.callerNumber ?? null,
      });
    },
  });

  if (!notification) {
    return null;
  }

  const formattedNumber = notification.callerNumber
    ? formatPhoneNumberForDisplay(notification.callerNumber)
    : null;

  return (
    <NotificationToast
      slideFadeIn
      customDetailsClick={(e) => {
        e.stopPropagation();
      }}
      title="Phone Error Detected"
      titleIcon={MdPhoneDisabled}
      titleIconColor="red.300"
      subTitle="You have been set to Inactive"
      details={
        <>
          <Text mb={1}>
            Your phone app (Zoiper) didn't respond when we tried to connect this call.
          </Text>
          {formattedNumber ? (
            <Text fontWeight="semibold" mb={1}>
              Caller: {formattedNumber}
            </Text>
          ) : null}
          <Text mb={1}>
            The call has been returned to the queue. You've been set to Inactive to prevent more
            missed calls.
          </Text>
          <Text>Please restart Zoiper and set yourself back to Active.</Text>
        </>
      }
      onClose={() => setNotification(null)}
    />
  );
};

export default SipFailureHandler;
